module.exports = ".row {\n  margin-right: 0px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/login/components/login-main/login-main.component.sass
// module id = ./src/app/modules/login/components/login-main/login-main.component.sass
// module chunks = main